import { Routes } from '@angular/router';
import { LoginGuard } from './core/guards/login/login.guard';
import { RoleGuard } from './core/guards/role/role.guard';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { SuperAdminLayout } from '@layouts/super-admin-layout/super-admin-layout';
import { AdminLayout } from '@layouts/admin-layout/admin-layout';
import { ManagerLayout } from '@layouts/manager-layout/manager-layout';
import { CoachLayout } from '@layouts/coach-layout/coach-layout';
import { NotFoundComponent } from '@shared/not-found/not-found';

export const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'auth',
    canActivate: [LoginGuard],
    loadChildren: () =>
      import('@features/auth/auth.routes')
        .then(m => m.AUTH_ROUTES)
  },
  {
    path: 'coach-join',
    redirectTo: 'auth/join-gym?type=coach',
    pathMatch: 'full'
  },
  {
    path: 'super-admin',
    canActivate: [RoleGuard , AuthGuard],
    data: {roles: ['SUPER_ADMIN']},
    component: SuperAdminLayout,
    loadChildren: () =>
      import('@/app/features/super-admin/super-admin.routes')
        .then(m => m.ADMIN_ROUTES)
  },
  {
    path: 'admin',
    canActivate: [RoleGuard , AuthGuard],
    data: {roles: ['ADMIN']},
    component: AdminLayout,
    loadChildren: () =>
      import('@/app/features/admin/admin.routes')
        .then(m => m.ADMIN_ROUTES)
  },
  {
    path: 'manager',
    canActivate: [RoleGuard , AuthGuard],
    data: {roles: ['GERANT', 'AGENT', 'MANAGER']},
    component: ManagerLayout,
    loadChildren: () =>
      import('@/app/features/manager/manager.routes')
        .then(m => m.MANAGER_ROUTES)
  },
  {
    path: 'coach',
    canActivate: [RoleGuard , AuthGuard],
    data: {roles: ['FREELANCE_COACH']},
    component: CoachLayout,
    loadChildren: () =>
      import('@/app/features/coach/coach.routes')
        .then(m => m.COACH_ROUTES)
  },
  // Doit rester en dernier : '**' capture toutes les routes non résolues
  { path: '**', component: NotFoundComponent }
];
